import { IconicPencil } from '@insify/design-system/iconic-icons';
import { useTranslation } from 'react-i18next';

import { useProfile } from '../../../api/queries/useProfile';
import { InfoDisplay } from '../../InfoDisplay';
import { Tabs } from '../../Tabs';
import { TypeformButton } from '../../TypeformButton/TypeformButton';
import styles from '../styles.module.css';

import type { Bundle, CompanyBundle, PersonalBundle } from '../../../types/Policy';

interface Props {
  bundle: Bundle;
}
export const ProductPersonalDetailsTab: React.FC<Props> = ({ bundle }) => {
  const { t } = useTranslation('policy');
  const { data: profileData } = useProfile();
  const profile = profileData?.result;

  return (
    <Tabs.Panel data-hj-suppress id='personal-details'>
      <h2>{t('personal_details.title')}</h2>
      <p>{t('personal_details.subtitle')}</p>

      <InfoDisplay.Container>
        <InfoDisplay.Label>{t('personal_details.name')}</InfoDisplay.Label>
        <InfoDisplay.Text>
          {bundle.type === 'personal' ? (bundle as PersonalBundle).name : (bundle as CompanyBundle).companyName}
        </InfoDisplay.Text>
      </InfoDisplay.Container>

      {bundle.type === 'company' && (
        <TypeformButton
          type='button'
          trackingId='editPersonalDetails'
          formType='change_form'
          policyType={bundle.type}
          kind='neutral'
          label={t('edit')}
          hiddenFields={{
            email: profile?.personalInformation.email,
            policy_number: bundle.coverages[0].policyNumber,
            country: bundle.country,
            change_type: 'company_registration',
            name: bundle.companyName,
          }}
          leftIcon={<IconicPencil />}
          className={styles.editButton}
          confirmation={t('change_confirmation')}
        />
      )}

      {/* TODO: add this to separate component */}
      <div style={{ width: '100%', borderBottom: '1px solid #e0e0e0', margin: '24px 0' }} />

      <h2>{t('contact.title')}</h2>
      <p>{t('contact.subtitle')}</p>

      <InfoDisplay.Container>
        <InfoDisplay.Label>{t('contact.email')}</InfoDisplay.Label>
        <InfoDisplay.Text>{profile?.personalInformation.email}</InfoDisplay.Text>

        <InfoDisplay.Label>{t('contact.phone')}</InfoDisplay.Label>
        <InfoDisplay.Text>{profile?.personalInformation.phoneNumbers![0]}</InfoDisplay.Text>
      </InfoDisplay.Container>

      <TypeformButton
        type='button'
        trackingId='editContactDetails'
        formType='change_form'
        policyType={bundle.type}
        kind='neutral'
        label={t('edit')}
        hiddenFields={{
          email: profile?.personalInformation.email,
          policy_number: bundle.coverages[0].policyNumber,
          change_type: 'contact_details',
          country: bundle.country,
          name: bundle.type === 'company' ? bundle.companyName : profile?.personalInformation.name,
        }}
        leftIcon={<IconicPencil />}
        className={styles.editButton}
        confirmation={t('change_confirmation')}
      />
    </Tabs.Panel>
  );
};
